import React from "react";
import { useLocation } from "react-router-dom";
import TestimonialsCarousel from "./TestimonialsCarousel";

/**
 * Hides the homepage testimonials carousel on dashboard-style routes where
 * marketing content would feel out of place AND was visibly bleeding into
 * the page (e.g. /admin).
 */
const HIDE_ON = ["/admin", "/login", "/register", "/account", "/checkout", "/order"];

export default function GlobalTestimonials() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname === p || pathname.startsWith(p + "/"))) {
    return null;
  }
  return <TestimonialsCarousel />;
}
